export default "__VITE_ASSET__woYgX92v__"